import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import ServiceHero from '../components/ServiceHero';
import ServiceFeatures from '../components/ServiceFeatures';
import ServiceDetails from '../components/ServiceDetails';
import ServiceCTA from '../components/ServiceCTA';
import { useTranslation } from 'react-i18next';

export default function AutomationPage() {
  const { t } = useTranslation();

  const features = [
    { icon: 'ri-robot-line', title: t('servicePages.automation.features.f1.title'), desc: t('servicePages.automation.features.f1.desc') },
    { icon: 'ri-flow-chart', title: t('servicePages.automation.features.f2.title'), desc: t('servicePages.automation.features.f2.desc') },
    { icon: 'ri-loop-left-line', title: t('servicePages.automation.features.f3.title'), desc: t('servicePages.automation.features.f3.desc') },
    { icon: 'ri-cpu-line', title: t('servicePages.automation.features.f4.title'), desc: t('servicePages.automation.features.f4.desc') },
    { icon: 'ri-notification-badge-line', title: t('servicePages.automation.features.f5.title'), desc: t('servicePages.automation.features.f5.desc') },
    { icon: 'ri-dashboard-line', title: t('servicePages.automation.features.f6.title'), desc: t('servicePages.automation.features.f6.desc') },
  ];

  const details = [
    {
      label: t('servicePages.automation.details.d1.label'),
      title: t('servicePages.automation.details.d1.title'),
      body: t('servicePages.automation.details.d1.body'),
      image: 'https://public.readdy.ai/ai/img_res/f0d4ea11b064051795f4a9d7978d66e2.jpg',
      reverse: false,
    },
    {
      label: t('servicePages.automation.details.d2.label'),
      title: t('servicePages.automation.details.d2.title'),
      body: t('servicePages.automation.details.d2.body'),
      image: 'https://readdy.ai/api/search-image?query=intelligent%20automation%20dashboard%20with%20real-time%20monitoring%20charts%2C%20automated%20task%20queues%20and%20performance%20metrics%20on%20dark%20themed%20monitors%2C%20cyan%20accent%20data%20visualization%2C%20professional%20operations%20center%20environment%2C%20abstract%20digital%20workflow%20streams%2C%20no%20people%2C%20high%20contrast%20moody%20lighting&width=800&height=500&seq=automation-detail-02&orientation=landscape',
      reverse: true,
    },
  ];

  return (
    <div className="min-h-screen bg-[#0f1419]">
      <Header />
      <main>
        <ServiceHero
          icon="ri-robot-line"
          label={t('servicePages.automation.label')}
          title={t('servicePages.automation.title')}
          subtitle={t('servicePages.automation.subtitle')}
          bgImage="https://readdy.ai/api/search-image?query=dark%20futuristic%20process%20automation%20background%20with%20glowing%20robotic%20workflow%20nodes%2C%20abstract%20digital%20pipeline%20streams%2C%20deep%20graphite%20navy%20atmosphere%20with%20cyan%20neon%20accent%20lighting%2C%20intelligent%20automation%20concept%2C%20ultra%20wide%20panoramic%2C%20cinematic%20dark%20moody%20professional%20environment%2C%20no%20people&width=1920&height=900&seq=automation-hero-bg-001&orientation=landscape"
        />
        <ServiceFeatures features={features} />
        <ServiceDetails details={details} />
        <ServiceCTA />
      </main>
      <Footer />
    </div>
  );
}
